export default function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ga/dist/esm/utils/removeLeadingSlash.js
// module id = 1071
// module chunks = 58